import config from "../config/config";

// Login lives on the Vectr platform (ivec-assist-frontend), not in this app —
// any logged-out state sends the browser back there.
export function redirectToPlatformLogin() {
    window.location.href = `${config.vectrPlatformUrl}/login`;
}

// This app lives in a tab the Vectr platform opened — on logout the tab
// should die, not linger on a login screen it doesn't own. Browsers only
// honor window.close() for script-opened tabs; a deep-linked / manually
// opened tab falls through to the platform login redirect instead.
export function closeTabOrRedirectToLogin() {
    window.close();
    redirectToPlatformLogin();
}

export function getToken() {
    const token = localStorage.getItem("token");
    if (!token) return redirectToPlatformLogin();
    return token
}

// Handoff from the Vectr app (port 3000): it opens this app with the bearer
// token as a query param. Must run before React renders so the Layout guard
// and getToken() already see the token in localStorage.
export function captureTokenFromUrl() {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");
    if (!token) return;

    localStorage.setItem("token", token);

    url.searchParams.delete("token");
    window.history.replaceState(null, "", url.pathname + url.search + url.hash);
}